import {ListItem} from "@domain/common/list-view/list-item";
import {NO_SELECTION} from "@components/document/custom-select-document-tag";

/**
 * Item dans la liste des types de pièce jointe
 *
 * @author Lionel GIMENEZ
 * @date 02/10/2023
 */
export class TypeDocument implements ListItem {
    idTypeDocument: number|typeof NO_SELECTION
    libelle: string;
    actif: boolean;
    typeObjet: string;
    ocr: boolean;
    used: boolean;

    getKey(): number|typeof NO_SELECTION {
        return this.idTypeDocument;
    }

}
